import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import SafeIcon from '../../common/SafeIcon';

export const AppStoreButton = ({ className = "" }) => (
  <a 
    href="#download-ios" 
    className={`flex items-center justify-center gap-3 bg-black hover:bg-gray-900 text-white px-5 py-3 rounded-xl transition-transform hover:scale-105 active:scale-95 shadow-md ${className}`}
  >
    <SafeIcon icon={FaApple} className="text-3xl" />
    <div className="flex flex-col items-start leading-none">
      <span className="text-[10px] uppercase tracking-wider mb-1">Download on the</span>
      <span className="text-lg font-semibold tracking-tight">App Store</span>
    </div>
  </a>
);

export const PlayStoreButton = ({ className = "" }) => (
  <a 
    href="#download-android" 
    className={`flex items-center justify-center gap-3 bg-black hover:bg-gray-900 text-white px-5 py-3 rounded-xl transition-transform hover:scale-105 active:scale-95 shadow-md ${className}`}
  >
    <SafeIcon icon={FaGooglePlay} className="text-2xl" />
    <div className="flex flex-col items-start leading-none">
      <span className="text-[10px] uppercase tracking-wider mb-1">GET IT ON</span>
      <span className="text-lg font-semibold tracking-tight">Google Play</span>
    </div>
  </a>
);